import React, { useCallback } from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import BackgroundImage from '../components/BackgroundImage';
import TopSection, { TopSectionProps } from '../components/TopSection';
import Colors from '../constants/Colors';
import { DateRange, DateSelectionRange, updateDateRange } from '../redux/dateRangeSlice';
import { updateDateComparisonRange } from '../redux/dateComparisonRangeSlice';
import ScreenEmptyState from '../components/ScreenEmptyState';
import { HappyScoreCategory } from '../constants/Types';
import isMobile from '../components/IsMobile';
import MobileHeader from './InternalEnvironment/components/MobileHeader';
import FixedDateComponent from '../components/FixedDateComponent';

export default function SatisfactionScreen() {
  const dispatch = useDispatch();
  const setRange = (dates: DateRange) => dispatch(updateDateRange(dates));
  const setCompareRange = (dates: DateRange) => dispatch(updateDateComparisonRange(dates));
  const notEmpty: boolean | undefined | null = useSelector((state:
    { emptyState: { notEmpty: boolean } }) => state.emptyState.notEmpty);

  const onConfirm = useCallback(
    (start: string, end: string, selectedRange: DateSelectionRange) => setRange(
      { start, end, selectedRange },
    ),
    [setRange],
  );

  const onCompareConfirm = useCallback(
    (start: string, end: string, selectedRange: DateSelectionRange) => setCompareRange(
      { start, end, selectedRange },
    ),
    [setCompareRange],
  );

  const topSectionProps: TopSectionProps = {
    screen: HappyScoreCategory.SATISFACTION,
  };

  if (isMobile) {
    return <MobileHeader
      screen={HappyScoreCategory.SATISFACTION}
      happyScoreMetric='group5OccupantSatisfaction'
      buildingSelectionOnly
    />;
  }

  return !notEmpty ? <ScreenEmptyState large /> : <ScrollView style={styles.container}>
    <BackgroundImage />
    <TopSection {...topSectionProps} />
    <FixedDateComponent onConfirm={onConfirm} onCompareConfirm={onCompareConfirm} liveEnabled />
  </ScrollView>;
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.light.hereworksBackground,
  },
});
